// 静态常量配置

export const kunpengConfig = {
  // 网站标题
  title: '鲲鹏共享科技',
  // 网站描述
  description: '鲲鹏共享云',
  // 网站关键词
  keywords: '鲲鹏共享云',
  // 网站备案号（示例：粤ICP备00000000号-1）
  icp: '闽ICP备2021011916号-22A',
  // 备案查询链接
  icpUrl: 'https://beian.miit.gov.cn/',
  // 版权所有
  copyright: '2025. All right reserved.',
  // 使用打包器处理后的静态资源路径
  logo: require('@/assets/images/common/kplogo.png'),
  // 作为 favicon 使用的图标（可为 png/jpg/ico）
  favicon: require('@/assets/images/common/kpFavicon.png'),
  // 下载链接
  DownloadUrl: 'https://www.kunpenggx.com/KunpengAPP/index.html',
}

export const KPRanYouConfig = {
  title: '染佑科技',
  description: '染佑科技，专业提供基于共享云的数字化解决方案',
  keywords: '染佑科技',
  icp: '闽ICP备2021011916号-23A',
  icpUrl: 'https://beian.miit.gov.cn/',
  copyright: '2025. All right reserved.',
  logo: require('@/assets/images/common/rylogo.jpg'),
  favicon: require('@/assets/images/common/ryFavicon.png'),
  DownloadUrl: 'https://www.ranyoukj.com/KPRanYouAPP/index.html',
}

export const KPShanNengConfig = {
  title: '闪能科技',
  description: '闪能科技，专业提供基于共享云的数字化解决方案',
  keywords: '闪能科技',
  icp: '闽ICP备2021011916号-24A',
  icpUrl: 'https://beian.miit.gov.cn/',
  copyright: '2025. All right reserved.',
  logo: require('@/assets/images/common/snlogo.jpg'),
  favicon: require('@/assets/images/common/snFavicon.png'),
  DownloadUrl: 'https://www.shannengdz.com/KPShanNengAPP/index.html',
}

export const NvWaConfig = {
  title: '女娲再生',
  description: '女娲再生，专业提供基于共享云的数字化解决方案',
  keywords: '女娲再生',
  icp: '闽ICP备2021011916号-25A',
  icpUrl: 'https://beian.miit.gov.cn/',
  copyright: '2025. All right reserved.',
  logo: require('@/assets/images/common/nwlogo.png'),
  favicon: require('@/assets/images/common/nwFavicon.png'),
  DownloadUrl: 'https://www.nvwazs.com/KPNvWaApp/index.html',
}

export default NvWaConfig